import { render } from "./Resume.vue?vue&type=template&id=0ac5fc3b"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__